<div class="activation-link-setup-fee vox-card">
  <div class="activation-link-setup-fee__name">
    <span class="activation-link-setup-fee__title" translate>
      {{setupFee?.name}}
    </span>
  </div>
  <div class="activation-link-setup-fee__amount">
    <div *ngIf="setupFee?.isEditable && isSelected" class="vox-input-group vox-input-group_dense">
      <input
        #amountInput
        type="number"
        class="vox-text-field activation-link-setup-fee__input"
        [(ngModel)]="amount"
        (ngModelChange)="onAmountChange($event)"
        (blur)="onBlur(amountInput)"
        step="0.01"
        min="0">
      <span class="vox-text-field__icon vox-text-field__icon_black activation-link-setup-fee__icon">{{setupFee?.currency}}</span>
    </div>
    <span *ngIf="!setupFee?.isEditable || !isSelected" class="activation-link-setup-fee__label">
      {{setupFee?.amount | number:'1.2-2'}} {{setupFee?.currency}}
    </span>
  </div>
</div>
